import React from "react";
import PropTypes from "prop-types";

import InfiniteTable from "./infiniteTable";
import SimpleTable from "./simpleTable";

import "react-virtualized/styles.css";
import "./table.scss";

const Table = props => {
  const { enableInfiniteLoading, innerRef, ...attrs } = props;

  if (enableInfiniteLoading) {
    return <InfiniteTable {...attrs} />;
  }
  return <SimpleTable {...attrs} ref={innerRef} />;
};

Table.propTypes = {
  enableInfiniteLoading: PropTypes.bool,
  innerRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func
  ])
};

Table.defaultProps = {
  enableInfiniteLoading: false
};

Table.displayName = "OrionTable";

export default Table;
